// @ts-ignore
const req = require.context('@/assets/icons', true, /\.svg$/)

// @ts-ignore
const requireAll = requireContext => requireContext.keys().map(requireContext)

requireAll(req)

export {}